import { toast } from "sonner";
import { Info, CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import { createElement } from "react";

// PATCH 36 Me4 — one toast contract for the whole platform. Severity carries a consistent icon;
// auto-dismiss timing is standardised by severity (errors linger, info is brief). Stacking,
// position and max-visible are configured once on the <Toaster> in App.js.
const DURATION = { info: 4000, success: 3500, warning: 6000, error: 8000 };

function raise(kind, message, opts = {}) {
  const icon = { info: Info, success: CheckCircle2, warning: AlertTriangle, error: XCircle }[kind];
  return toast[kind === "warning" ? "warning" : kind === "success" ? "success" : kind === "error" ? "error" : "message"](
    message,
    { duration: DURATION[kind], icon: createElement(icon, { size: 15 }), ...opts },
  );
}

export const notify = {
  info: (m, o) => raise("info", m, o),
  success: (m, o) => raise("success", m, o),
  warning: (m, o) => raise("warning", m, o),
  error: (m, o) => raise("error", m, o),
};

export { DURATION as TOAST_DURATION };
